export class OrganizationalInfo {
  OrganizationalId: number = 0;
  ProjectCode: string = "";
  EmployeeCode: string = "";
  
  SuperviserCode: string = "";
  
  ProjectRoleId: number = 0;
  
  OrganizationalLevel: number = 0;
  OrganizationalImgPath: string = "";
  OrganizationalImgBase64: string = "";
  OrganizationalCreateDate: string = "";
  OrganizationalCreateBy: string = "";
  OrganizationalUpdateDate: string = "";
  OrganizationalUpdateBy: string = "";
  OrganizationalActive: string = "";
  OrganizationalFlagDelete: string = "";


  EmployeeName: string = "";
  SuperviserName: string = "";
  ProjectRoleName: string = "";
  OrganizationalTeamId: number = 0;
  OrganizationalTeamName: string = "";
}
